import React, { useState } from 'react';

type SearchState = {
  search: string;
  setSearch?: (search: string) => void;
}

export const SearchContext = React.createContext({ search: '' } as SearchState);

export const SearchStateProvider = (props: { children: any }): JSX.Element => {
  const [searchState, setSearchState] = useState<SearchState>({ search: '' });

  const setSearch = (search: string): void => {
    setSearchState({ ...searchState, search });
  };

  return <SearchContext.Provider value={{ ...searchState, setSearch }}>{props.children}</SearchContext.Provider>;
};
